import type { AudioBank } from "../banks/types";
import { SHELL_BUNDLE_NAMES } from "../../boot/defaults/BundleNames";

/** The shell bank's music bed: the base music unless `GameAudioOverrides.baseMusicId` names another. */
export const SHELL_BASE_MUSIC_ID = "music_base";

/**
 * Minimal shell audio bank — only entries every slot game uses, regardless
 * of mechanic or feature set. Mechanic-specific and game-specific entries
 * (cascade column drop, multiplier/scatter SFX, feature music) live in each
 * game's `createGameAudioOverrides()` bank.
 */
export const DefaultAudioBank: AudioBank = {
  id: "game-shell-default",
  assets: [
    {
      id: SHELL_BASE_MUSIC_ID,
      locator: { kind: "bundle_audio", bundle: { kind: "local", name: SHELL_BUNDLE_NAMES.audio }, key: `audio/${SHELL_BASE_MUSIC_ID}` },
      category: "music",
    },

    {
      id: "ui_click",
      locator: { kind: "bundle_audio", bundle: { kind: "local", name: SHELL_BUNDLE_NAMES.audio }, key: "audio/ui_click" },
      category: "ui",
      defaultOpts: { priority: 50, essential: true },
    },
    {
      id: "spin_start",
      locator: { kind: "bundle_audio", bundle: { kind: "local", name: SHELL_BUNDLE_NAMES.audio }, key: "audio/spin_start" },
      category: "ui",
      defaultOpts: { priority: 60, essential: true },
    },
    {
      id: "spin_slam",
      locator: { kind: "bundle_audio", bundle: { kind: "local", name: SHELL_BUNDLE_NAMES.audio }, key: "audio/spin_slam" },
      category: "ui",
      defaultOpts: { priority: 60, essential: true },
    },

    {
      id: "bet_increase",
      locator: { kind: "bundle_audio", bundle: { kind: "local", name: SHELL_BUNDLE_NAMES.audio }, key: "audio/bet_increase" },
      category: "ui",
      defaultOpts: { priority: 60, essential: true },
    },
    {
      id: "bet_decrease",
      locator: { kind: "bundle_audio", bundle: { kind: "local", name: SHELL_BUNDLE_NAMES.audio }, key: "audio/bet_decrease" },
      category: "ui",
      defaultOpts: { priority: 60, essential: true },
    },

    {
      id: "bigwin_start",
      locator: { kind: "bundle_audio", bundle: { kind: "local", name: SHELL_BUNDLE_NAMES.audio }, key: "audio/bigwin_start" },
      category: "sfx",
      defaultOpts: {
        priority: 5,
        stopOnSlam: false,
        protectFromSteal: false,
        gain: 4,
      },
    },
    {
      id: "bigwin_count_start",
      locator: { kind: "bundle_audio", bundle: { kind: "local", name: SHELL_BUNDLE_NAMES.audio }, key: "audio/bigwin_count_start" },
      category: "sfx",
      defaultOpts: {
        priority: 5,
        stopOnSlam: false,
        protectFromSteal: false,
        gain: 6,
      },
    },
    {
      id: "bigwin_count_end",
      locator: { kind: "bundle_audio", bundle: { kind: "local", name: SHELL_BUNDLE_NAMES.audio }, key: "audio/bigwin_count_end" },
      category: "sfx",
      defaultOpts: {
        priority: 5,
        stopOnSlam: false,
        protectFromSteal: false,
        gain: 6,
      },
    },
    {
      id: "bigwin_end",
      locator: { kind: "bundle_audio", bundle: { kind: "local", name: SHELL_BUNDLE_NAMES.audio }, key: "audio/bigwin_end" },
      category: "sfx",
      defaultOpts: {
        priority: 5,
        stopOnSlam: false,
        protectFromSteal: false,
        gain: 4,
      },
    },
  ],
};
